











import {Component, Vue, Prop} from 'vue-property-decorator';
import {VCarousel, VCarouselItem} from 'vuetify/lib';
@Component({
	components: {
		VCarousel,
		VCarouselItem,
	},
})
export default class Carousel extends Vue {
	@Prop()
	public height!: string;

	@Prop()
	public items!: string[];

	private kill = 3.4;
}
